import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'

function CompanyConfirmationAdminSideMenu() {
  return <OnboardingStepperSideMenu />
}

export { CompanyConfirmationAdminSideMenu }
